import moment from 'moment'

export default (utcDate) => {
    var testDateUtc = moment.utc(utcDate)
    var localDate = moment(testDateUtc).local()

    return localDate
}